module.exports = __webpack_public_path__ + "519b13894418d2401a14e9fa06871e28.png";